module.exports = {
    "/": 'Dashboard',
    "/orders": 'All Orders',
    "/account-approval": 'Account Approval',
    '/merchants': 'All Merchants',
    '/customers': 'All Customers',
    '/settlements': 'Settlements',
    '/earnings': 'Earnings'
}